import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { OtherMeasurementAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-other-measurement-slot',
    templateUrl: './other-measurement-slot.component.html',
    styleUrl: './other-measurement-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtherMeasurementSlotComponent implements SheetSlotComponentBase {

	action!: OtherMeasurementAction;
	value!: string | null;

	@Input('action') set updateAction(action: OtherMeasurementAction | null) {
		this.action = action as OtherMeasurementAction;
		this.value = this.action.measurement?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}